const DATE_STRING_PATTERN = /^[A-Z][a-z]{2}\s[A-Z][a-z]{2}\s\d{1,2}\s\d{4}$/;

const utcDateFormatter = new Intl.DateTimeFormat("en-US", {
  timeZone: "UTC",
  weekday: "short",
  month: "short",
  day: "2-digit",
  year: "numeric",
});

export const formatCertificateDate = (value?: string | Date | null): string => {
  if (!value) return "";

  if (typeof value === "string" && DATE_STRING_PATTERN.test(value.trim())) {
    return value.trim();
  }

  const date = value instanceof Date ? value : new Date(value);

  if (Number.isNaN(date.getTime())) {
    return String(value);
  }

  const parts = utcDateFormatter.formatToParts(date);
  const getPart = (type: string) =>
    parts.find((part) => part.type === type)?.value || "";

  return `${getPart("weekday")} ${getPart("month")} ${getPart("day")} ${getPart("year")}`;
};
